import React, { useEffect, useMemo, useState } from "react";
import { Labelbox } from "../../components";
import { CLIENT_ACTION } from "../../redux/action";
import ContractPayment from "../contract_payment";
import { useSelector, useDispatch } from "react-redux";
import Empty from "antd/es/empty";
import "./index.scss";

const MangeClientRole = () => {
  const dispatch = useDispatch();

  const {
    client: { clientMaster, activeClients },
  } = useSelector((state) => state);

  const [clientId, setClientId] = useState("");

  const USER_DATA = useMemo(() => {
    return activeClients.find((d) => d.client_id === clientId);
  }, [clientId, activeClients]);

  useEffect(() => {
    if (!clientMaster?.length) dispatch(CLIENT_ACTION.getActiveClients());
  }, []);

  return (
    <div style={{ backgroundColor: "#f5f7fa", paddingTop: "24px", minHeight: "100%" }}>
      <div className="manage-client-role-selectors">
        <div className="manage-client-role-selector-group">
          <Labelbox
            type="select"
            dropdown={clientMaster}
            labelname="Select Client"
            value={clientId}
            changeData={(value) => setClientId(value)}
          />
        </div>
      </div>

      {clientId ? (
        <ContractPayment userId={clientId} USER_DATA={USER_DATA} />
      ) : (
        <Empty />
      )}
    </div>
  );
};
export default MangeClientRole;
